var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolber({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 116,
    viewBox: "0 0 154 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4616 35.2105L42.8138 95.2925L41.3003 103.158L118.952 102.781C122.44 102.765 125.533 99.6549 126.648 95.0348L140.421 38.3137C141.273 34.8073 139.405 31.1588 136.759 31.1621L58.1467 31.2447C56.4358 31.2414 54.9025 32.8674 54.4616 35.2105Z",
    fill: "#FE6100"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4616 35.2105L42.8138 95.2925L41.3003 103.158L118.952 102.781C122.44 102.765 125.533 99.6549 126.648 95.0348L140.421 38.3137C141.273 34.8073 139.405 31.1588 136.759 31.1621L58.1467 31.2447C56.4358 31.2414 54.9025 32.8674 54.4616 35.2105Z",
    fill: "#212121"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.512 91.2136L103.286 24.6508C102.957 21.9243 100.789 19.8885 98.2324 19.8984L80.2015 19.9546C79.5314 19.9622 78.8699 20.1068 78.2572 20.3795C77.6446 20.6522 77.0937 21.0474 76.6381 21.5409L68.0832 30.6854L17.9387 30.9564C14.8754 30.973 12.5195 33.8878 12.9242 37.1596L20.5611 98.6793C20.8901 101.402 23.0584 103.435 25.6084 103.432L113.016 103.256C122.749 103.458 123.68 100.573 123.68 100.573C112.506 103.055 111.512 91.2302 111.512 91.2136Z",
    fill: "#FE6100"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8215 77.9013L70.8734 81.0806L48.1702 60.5641L51.1183 57.3849L73.8215 77.9013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6395 56.6818L72.8969 59.6264L52.3554 81.7853L49.0947 78.8407L69.6395 56.6818Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolber);
export default __webpack_public_path__ + "static/media/folber.bd43f28ab0d9be9e1b15a09bf236eca2.svg";
export { ForwardRef as ReactComponent };